export const getUserInitials = (userName: string | undefined) => {
  return userName
    ?.split(' ')
    .map((word) => word.charAt(0))
    .join('')
    .slice(0, 2);
};
